import { Component, input, output } from '@angular/core';

@Component({
  selector: 'gs-event-selection-head',
  template: `
    <input
      type="checkbox"
      [checked]="checked()"
      [indeterminate]="indeterminate()"
      aria-label="Toggle event selection"
      (change)="onToggle($event)" />
  `,
  styles: [
    `
      :host {
        display: inline-flex;
      }
    `,
  ],
})
export class GsEventSelectionHeadComponent {
  readonly checked = input(false);
  readonly indeterminate = input(false);

  readonly toggled = output<boolean>();

  protected onToggle(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.toggled.emit(checkbox.checked);
  }
}
